import { render, staticRenderFns } from "./CardPointe.vue?vue&type=template&id=bda11d80&lang=pug"
import script from "./CardPointe.vue?vue&type=script&lang=js"
export * from "./CardPointe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports